import { ReactElement } from 'react';

function Footer(): ReactElement {
  return (
    <footer className="w-auto flex justify-center py-3">
      <div>
        <a
          className="text-white"
          href="https://cronos.org/docs/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Docs
        </a>
      </div>
      <span className="text-white mx-2">|</span>
      <div>
        <a
          className="text-white"
          href="https://cronos.org/docs/bridge/webapp.html#transfer-assets-from-crypto-org-chain-using-cronos-bridge-web-app"
          rel="noopener noreferrer"
          target="_blank"
        >
          Guide
        </a>
      </div>
      <span className="text-white mx-2">|</span>
      <div>
        <a
          className="text-white"
          href="https://cronos.org/docs/bridge/webapp.html#faq"
          rel="noopener noreferrer"
          target="_blank"
        >
          FAQ
        </a>
      </div>
    </footer>
  );
}

export default Footer;
